<template>
    <div class="carousel-wrapper">
        <div v-if="galleries.length > 0">
  <VueSlickCarousel v-bind="settings">
    <div v-for="gallery in galleries" class="img-wrapper">
      <div class="carousel-image">                 
        <img imgCarousel :src="gallery.uriLarge" />
        <div class="image-overlay">
          <h2 v-html="gallery.title.replace(/<\/?p>/g, '')"></h2>
        </div>                   
      </div>               
    </div>
  </VueSlickCarousel>
</div>

<div v-else class="empty-gallery">
  <!-- Aquí puedes agregar un mensaje o cualquier otro contenido que desees mostrar -->
</div>
    </div>
</template>

<script>


    import VueSlickCarousel from 'vue-slick-carousel'
    import 'vue-slick-carousel/dist/vue-slick-carousel.css'

    export default {
        name: 'Carousel',
        components: { VueSlickCarousel },
        props: {
            galleries: Array,
        },
        data() {
            return {
                settings: {
                    arrows: true,
                    dots: true,
                }
            }
        }
    }
</script>

<style>
.carousel-image {
  position: relative;
}

.image-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: var(--blanket);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  color: var(--text-oncolor);
  padding: 5px;
height: 40px;
}

.image-overlay h2 {
font-size: 0.75rem;
}

.empty-gallery {
    width: 100%;
    height: 400px;
    background-color: var(--bg-level4);
  }
</style>